module.exports = __webpack_public_path__ + "static/media/01.34a4cd5c.png";